module.exports = __webpack_public_path__ + "img/scope2category1.59442c43.svg";